import { getErrorMessage } from "../../utils";
import FetchService from "../../FetchService/CustomService";
import { Filter, GetTabFiltersParams, TabFiltersResponse } from "./types";
import { AxiosResponse } from "axios";

const BaseUrl = process.env.BASE_URL;

/**
 * Service for handling job filter related API requests
 */
const FilterService = {
  /**
   * Get filter options for a specific tab with optional applied filters
   * @param params - Object containing tab and filter parameters
   * @returns Promise resolving to filter data
   */
  async getTabFilters({
    tabId,
    selectedFilters = {}
  }: GetTabFiltersParams): Promise<Filter[]> {
    try {
      // Build the query parameters as an object (not URLSearchParams)
      const queryParams = {
        tab: tabId
      };

      // Add all filter parameters
      Object.entries(selectedFilters).forEach(([key, values]) => {
        if (values && values.length > 0) {
          queryParams[key] = values.join(",");
        }
      });

      const url = `${BaseUrl}/recruiter/job/tab-filters`;

      const response = (await FetchService.getCall({
        url,
        query: queryParams,
        loaderConfig: { hasLoader: false }
      })) as AxiosResponse;

      return response?.data?.data || [];
    } catch (err) {
      return Promise.reject(getErrorMessage(err));
    }
  }
};

export default FilterService;
